import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "c-checkbox-group" }
const _hoisted_2 = ["id", "checked", "onInput"]
const _hoisted_3 = ["for"]

import { computed, PropType, reactive } from "vue"
// 单个选项
type CheckboxOption = {
  label: string,	// 显示的label
  value: string | number, // 对应的值
  key?: string,
  checked?: boolean // 是否选中
}

// 组件属性
type CheckboxGroupProp = {
  value: Array<string | number>, // 选中的值数组
  options: CheckboxOption[] // 可选列表
}

const __default__ = {
  name:'CheckboxGroup'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: {
    type: Array,
    default: () => []
  },
  options: {
    type: Array as PropType<CheckboxOption[]>,
    default: () => []
  }
},
  emits: ["update:value"],
  setup(__props, { emit }) {

const props = __props;



// 组件属性


// 初始化选项:加入key属性和checked属性
function initOptions() {
  return props.options.length
    ? props.options.map(op => {
      if (!op.key) {
        op.key = op.value.toString()
      }
      if (props.value.length) {
        op.checked = !!props.value.includes(op.value)
      } else {
        op.checked = false
      }
      return op
    })
    : []
}

// 响应式状态
const state = reactive({
  options: initOptions()
})

// 选中的选项
const selectedOptions = computed(() => state.options.filter(op => op.checked))

// 更新与传递
const update = (e: Event, item: CheckboxOption) => {
  const targetChecked = (e.target as HTMLInputElement).checked
  const target = state.options.find(op => op.key === item.key)
  if (target) {
    target.checked = targetChecked
    emit("update:value", selectedOptions.value.map(op => op.value), selectedOptions)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.options, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "-checkbox-group__option",
        key: item.key
      }, [
        _createElementVNode("input", {
          type: "checkbox",
          id: item.key,
          checked: item.checked,
          onInput: (e) => { update(e, item) }
        }, null, 40, _hoisted_2),
        _createElementVNode("label", {
          for: item.key
        }, _toDisplayString(item.label), 9, _hoisted_3)
      ]))
    }), 128))
  ]))
}
}

})